import { Controller, Loader, IDynamicLoader } from '@tencent/workbench';
import { FORM_CONFIGS } from './config';
import { Form } from '@tencent/wb-ext-form';
import { FormItemName } from '@framework/workbench/drawer/constants';
import { ISlideSizeFeature } from './slide-size-interface';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { SlideSizeType } from '@src/slide/domain/ui-model/element-modeles/property/slide-size/slide-size.interface';

@Controller({ formItems: FORM_CONFIGS })
export class SlideSizeController {
    constructor(@Loader(ISlideSizeFeature) private loader: IDynamicLoader<ISlideSizeFeature>) {}

    private get feature() {
        return this.loader.instance!;
    }

    @Form(FormItemName.SLIDE_SIZE_SELECT, 'value')
    public getSlideSizeSelectVal(): string {
        return this.feature.getSlideSizeType();
    }

    @Form(FormItemName.SLIDE_SIZE_SELECT, 'onChange')
    public changeSlideSizeSelect(slideSize: string): void {
        const actionType = +slideSize === SlideSizeType.SLIDE_SIZE_16_9
            ? ActionType.SLIDE_WIDE : ActionType.SLIDE_STANDARD;
        this.feature.updateProps(actionType, slideSize);
    }
}
